<template>
  <div
    class="d-flex p-3 mb-3"
    :class="checked ? 'active' : 'container'"
    @click="onClick"
    v-if="!disabled"
  >
    <div class="radio">
      <input
        ref="inputRef"
        type="radio"
        :id="id"
        :name="name"
        :value="value"
        :checked="checked && isActive"
      />
      <span />
    </div>
    <div class="g-col-8 w-100">
      <p id="text" class="fw-bold text-black m-0 text">{{ text }}</p>
      <p id="description" class="m-0 description">{{ description }}</p>
      <slot></slot>
    </div>
  </div>
  <div id="verifying-card" class="container-disabled mb-3 d-flex p-3" v-else>
    <div class="red-line"></div>
    <div class="g-col-8">
      <p id="text" class="fw-bold text-black mb-1 text">{{ text }}</p>
      <p id="description" class="m-0 description">{{ description }}</p>
      <div class="mt-3 w-100" v-if="reason">
        <p class="fw-bold text-black mt-3">
          {{ reason }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps<{
  id?: string;
  text?: string;
  name?: string;
  description?: string;
  reason?: string;
  value?: string;
  isActive?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "onchange", value?: string): void;
}>();

const checked = ref<boolean>(false);

watch(
  () => props.isActive,
  (n) => {
    checked.value = n ?? false;
  }
);

const onClick = () => {
  emit("onchange", props.value);
  checked.value = true;
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.container {
  border-radius: 5px;
  border: 1px solid var(--grey-borders, #d9d7dd);
  background: var(--white, #fff);
}

input[type="radio"] {
  display: none;
}

.active {
  border-radius: 5px;
  border: 1px solid var(--primary, #aed3ad);
  background: #e6f4ea;
}

.text {
  font-size: 16px;
  line-height: 24px;
}

.description {
  font-size: 14px;
  line-height: 20px;
}

.container-disabled {
  position: relative;
  border-radius: 5px !important;
  border: 1px solid #d1d1d1;
  background: #fbfbfb;
  display: flex;
  align-items: center;
  opacity: 0.45;
}

.red-line {
  width: 5px;
  height: 100%;
  background-color: #c9372c;
  position: absolute;
  left: 0;
  top: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.g-col-8 {
  margin-left: 5px;
}

html,
body * {
  font-family: Inter;
}
</style>
